import { PrivateRouteProps } from './private-route-props.interface';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from 'src/contexts/AuthContext/AuthContext';
import { useLanguageNavigation } from 'src/hooks/use-language-navigation';

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { accessToken, isAuthLoading } = useAuthContext();
  const { getLocalizedPath } = useLanguageNavigation();

  if (isAuthLoading) {
    return null;
  }

  if (!accessToken) {
    return <Navigate to={getLocalizedPath('/')} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
